<script lang="ts" setup>
import type { EpgBroadcastRatingParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  epgBroadcastRating: EpgBroadcastRatingParagraph['epgBroadcastRating']
}>()

const setBarClass = (bar: number, value: number) => ({
  'bx-epg-rating__bar': true,
  'bx-epg-rating__bar--filled': value >= bar
})
</script>

<template v-if="ratings.length > 0">
  <div class="bx-content bx-epg-rating bx-typo--vod-epg">
    <h3>
      {{ epgBroadcastRating.headline }}
    </h3>
    <div class="bx-epg-rating__wrapper">
      <div v-for="{ name, value } in epgBroadcastRating.ratings"
           :key="name"
           class="bx-epg-rating__item">
        <div>
          <span v-for="bar in 3"
                :key="bar"
                :class="setBarClass(bar, value ?? 0)" />
        </div>
        <span class="bx-typo-epg-rating-category">
          {{ name }}
        </span>
      </div>
    </div>
  </div>
</template>
